<template>
  <div class="partner">
    <div class="shadow"></div>
    <div class="bank">
      <div class="bank-left" @click="openBank()"></div>
      <div class="bank-right">
        <p>
          <span style="font-weight: bold;">学分银行</span>是借鉴与模拟银行的功能和特点，以学分为计量单位，按照统一的标准，对学习者的各类学习成果进行认证与核算，实现各级各类学习成果的存储、积累与转换的学习激励制度和教育管理制度。
        </p>
        <p style="font-weight: bold;padding-top: 20px;">▶ 服务对象、内容与方式</p>
        <p style="padding-top: 10px;">（一）服务对象</p>
        <p>职业教育国家学分银行主要服务对象为机构和个人，机构包括：培训评价组织和试点院校，个人包括：院校内学生和社会成员。</p>
        <p style="padding-top: 10px;">（二）服务内容</p>
        <p>职业教育国家学分银行为机构用户提供批量账户开设和学习成果登记、认定、存储等服务，为个人提供个人学习账号开设和学习成果登记、认定、存储、积累、转换等服务。</p>
        <p style="padding-top: 10px;">（三）服务方式</p>
        <p>职业教育国家学分银行依托网站、微信公众号，提供在线服务。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    openBank() {
      window.open("https://www.ncb.edu.cn/home", "_blank");
    },
  },
};
</script>

<style>
.shadow {
  height: 100px;
  width: 100%;
  background-color: #d7d7d7;
}
.bank {
  width: 1200px;
  min-height: 300px;
  display: flex;
  margin: 45px auto 150px;
}
.bank-left {
  width: 385px;
  height: 398px;
  background: url(http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/xuefen.png)
    repeat 100% 100%;
}
.bank-left:hover {
  cursor: pointer;
}

.bank-right {
  line-height: 29px;
  font-size: 18px;
  margin-left: 50px;
  width: 766px;
}
</style>
